<template>
  <div>
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item>
          <a-input
            class="vd-input-xs"
            v-model="search.username"
            placeholder="用户名"
            allowClear
          />
        </a-form-item>
        <a-form-item>
          <a-select
            style="width: 216px"
            v-model="search.groups"
            mode="multiple"
            placeholder="权限组"
            allowClear
          >
            <a-select-option
              v-for="item in this.roleList"
              :key="item.id"
              :value="item.id"
              :disabled="item.id === 1"
            >
              <template v-if="item.key !== 1">
                <span
                  :style="{ 'padding-left': (item.deep - 1) * 8 + 'px' }"
                  slot="label"
                ></span>
                {{ item.last ? ' └ ' + item.name : ' ├ ' + item.name }}
              </template>
              <template v-else>
                {{ item.name }}
              </template>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-cascader
            style="width: 216px"
            :options="areaTree"
            v-model="search.area"
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            placeholder="请选择所属地区"
            :change-on-select="true"
          />
        </a-form-item>
        <a-form-item>
          <a-button @click="searchData" type="search" class="common-button">
            搜索
          </a-button>
          <a-button type="search">重置条件</a-button>
        </a-form-item>
      </a-form>
    </div>

    <div class="vd-gl-content">
      <a-row type="flex" class="vd-table-head">
        <a-col flex="auto" class="vd-table-name"> 成员列表</a-col>
        <a-col class="vd-table-tool">
          <a-button @click="modify({})"> 添加成员 </a-button>
          <!-- <a-divider type="vertical" />
          <a-icon class="common-icon" type="reload"></a-icon> -->
        </a-col>
      </a-row>

      <a-table
        :data-source="table"
        :defaultExpandAllRows="true"
        :pagination="pagination"
        :loading="loading"
        row-key="id"
        size="small"
      >
        <a-table-column title="ID" data-index="id" />
        <a-table-column title="用户名" data-index="username" />
        <a-table-column title="昵称" data-index="nickname" />
        <a-table-column title="手机号" data-index="mobile" />
        <a-table-column title="权限组" data-index="auth_name">
          <template slot-scope="itme">
            <a-tag v-for="(i, index) in itme" :key="index">{{ i }}</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="级别" data-index="major">
          <template slot-scope="item">
            {{ item === 0 ? '员工' : '管理' }}
          </template>
        </a-table-column>

        <a-table-column title="所属地区" data-index="area_name">
          <template slot-scope="text">
            <span>
              <a-tag>{{ $HelperUtil.isEmpty(text) ? '最高' : text }}</a-tag>
            </span>
          </template>
        </a-table-column>
        <a-table-column title="所属项目" data-index="category_name">
          <template slot-scope="item">
            {{ item || '网推' }}
          </template>
        </a-table-column>
        <a-table-column title="状态" data-index="status">
          <template slot-scope="text, record">
            <template v-if="record.id !== 1">
              <template v-if="record.status === 1">
                <a-popconfirm
                  title="禁用该用户?"
                  ok-text="禁用"
                  cancel-text="取消"
                  @confirm="modifyStatus(record.id, 'delete')"
                >
                  <a-icon
                    slot="icon"
                    type="exclamation-circle"
                    style="color: red"
                  />
                  <a-tag color="cyan">已启用</a-tag>
                </a-popconfirm>
              </template>
              <template v-else>
                <a-popconfirm
                  title="开启该用户?"
                  ok-text="开启"
                  cancel-text="取消"
                  @confirm="modifyStatus(record.id, 'recovery')"
                >
                  <a-icon
                    slot="icon"
                    type="exclamation-circle"
                    style="color: green"
                  />
                  <a-tag color="red">启用</a-tag>
                </a-popconfirm>
              </template>
            </template>
          </template>
        </a-table-column>
        <a-table-column title="最后登陆时间" data-index="login_time">
          <template slot-scope="text">
            <span>{{ $FormatUtil.timestamp2date(text, 'YYYY-MM-DD') }}</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" align="center">
          <template slot-scope="record">
            <template v-if="record.id !== 1">
              <a-tooltip title="修改基础信息">
                <a-icon
                  type="edit"
                  class="common-icon"
                  @click="modify(record)"
                />
              </a-tooltip>
              <a-tooltip
                v-if="$AuthUtil.authRoute('/auth/user/major')"
                :title="record.major === 0 ? '设为管理' : '设为员工'"
              >
                <a-icon
                  :type="record.major === 0 ? 'user-add' : 'user-delete'"
                  class="common-icon"
                  @click="setMajor(record)"
                />
              </a-tooltip>
            </template>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!-- 模态框 -->
    <a-modal :visible="visible" width="80%" :footer="null" @cancel="cancel">
      <div>
        <a-icon type="info-circle" style="color: #40a9ff" />
        注意事项!
        <ul>
          <li>新建普通用户时角色组勾选普通用户,不然账号会无法登陆</li>
          <li>
            添加推广员前请 认真阅读 一下文字 谢谢配合: <br />
            为减少重复用户
            <span class="red-text">防止歧义出现</span>
            各地市需要添加到县区的推广码时需要按照以下 规则 进行添加<br />
            <span class="red-text">用户名 必须为拼音 </span> 使用新工号
            若想建立地市的账号 以潍坊高密为例: weifanggaomi <br />
            <span class="red-text">昵称 必须为中文 </span> 以潍坊高密为例:
            潍坊高密 <br />
            添加到活动中的显示为↓<br />
            <img :src="info" alt="" style="width:800px" />
          </li>
        </ul>
      </div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        layout="horizontal"
      >
        <a-form-model-item label="角色组" prop="groups">
          <a-select style="width: 216px" v-model="form.groups" mode="multiple">
            <a-select-option
              v-for="item in roleList"
              :key="item.id"
              :value="item.id"
              :disabled="item.id === 1"
            >
              <template v-if="item.key !== 1">
                <span
                  :style="{ 'padding-left': (item.deep - 1) * 8 + 'px' }"
                  slot="label"
                ></span>
                <template v-if="item.last">
                  {{ ' └ ' + item.name }}
                </template>
                <template v-else>
                  {{ ' ├ ' + item.name }}
                </template>
              </template>
              <template v-else>
                {{ item.name }}
              </template>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="管理地区" prop="area">
          <a-tree
            v-model="form.area"
            :tree-data="areaTree"
            :auto-expand-parent="true"
            :replace-fields="{ title: 'name', key: 'id' }"
            :checkable="true"
            :default-expand-all="false"
          />
        </a-form-model-item>
        <a-form-model-item label="所属地区" prop="area_path">
          <!-- 联机选择器 -->
          <a-cascader
            style="width: 328px"
            :options="areaTree"
            v-model="form.area_path"
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            placeholder="请选择用户所属地区"
            :change-on-select="true"
          />
        </a-form-model-item>

        <a-form-model-item label="所属项目" prop="category_id">
          <a-select
            style="width: 156px"
            v-model="form.category_id"
            placeholder="请选择项目类型"
            allowClear
          >
            <a-select-option v-for="item in subList" :key="item.id">
              {{ item.nickname }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="QQ群管理地区" prop="qq_area">
          <a-select style="width: 216px" v-model="form.qq_area" mode="multiple">
            <a-select-option
              v-for="item in areaList"
              :key="item.login_qq"
              :value="item.login_qq"
            >
              {{ item.zh }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="用户名" prop="username">
          <a-input
            class="vd-input-s"
            v-model="form.username"
            :disabled="modalType && (!$AuthUtil.authRoute('/auth/user/username'))"
            placeholder="用户名"
          />
        </a-form-model-item>

        <a-form-model-item label="昵称" prop="nickname">
          <a-input
            class="vd-input-s"
            v-model="form.nickname"
            placeholder="昵称"
          />
        </a-form-model-item>

        <a-form-model-item label="密码" prop="pwd">
          <a-input
            class="vd-input-s"
            type="password"
            v-model="form.pwd"
            placeholder="密码"
          />
        </a-form-model-item>

        <a-form-model-item v-if="form.pwd" label="确认密码" prop="confirmPwd">
          <a-input
            class="vd-input-s"
            type="password"
            v-model="form.confirmPwd"
            placeholder="确认密码"
          />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 8, offset: 8 }">
          <a-button type="primary" @click="confirm">
            {{ modalType ? '修改' : '新建' }}
          </a-button>
          <a-button style="margin-left: 20px" @click="cancel">
            取消
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { get_sub } from '@/api'
import {
  getRoleApi,
  get_area_tree,
  get_admin_list,
  modify_status,
  set_major,
  modify_admin,
} from '@/api/auth'
import store from '@/store'
import info from '@/assets/info.jpg'

export default {
  name: 'User',
  data() {
    let validateUsername = (rule, value, callback) => {
      if (!this.$HelperUtil.isEmpty(value)) {
        // 检测是否合法
        if (this.$HelperUtil.cha(value)) {
          callback(new Error('用户名中不能有汉字'))
        }
      } else {
        callback(new Error('请输入用户名'))
      }
      callback()
    }
    let validatePass = (rule, value, callback) => {
      if (!this.$HelperUtil.isEmpty(value)) {
        // 检测是否合法
        if (!this.$HelperUtil.checkPassword(value)) {
          callback(new Error('密码长度6-15位,由数字和字母组成'))
        }
      }
      callback()
    }
    let validatePass2 = (rule, value, callback) => {
      if (!this.$HelperUtil.isEmpty(this.form.pwd)) {
        if (value === '') {
          callback(new Error('请输入确认密码'))
        } else if (value !== this.form.pwd) {
          callback(new Error('两次密码不匹配!'))
        }
      }
      callback()
    }
    return {
      info,
      modalType: false,
      roleList: [],
      subList: [],
      areaTree: [],
      // table
      table: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      defaultExpandAll: false,
      // 查询条件
      search: {
        username: '',
        groups: [],
        area: [],
      },
      form: {
        id: 0,
        groups: [],
        area: [],
        username: undefined,
        nickname: undefined,
        pwd: undefined,
        confirmPwd: undefined,
        category_id: undefined,
        area_path: [],
        qq_area: [],
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 15,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      visible: false,
      loading: {
        size: 'large',
        spinning: true,
      },
      rules: {
        groups: [
          { required: true, message: '请选择所属权限组', trigger: 'blur' },
        ],
        area: [{ required: true, message: '请选择管理地区', trigger: 'blur' }],
        area_path: [
          { required: true, message: '请选择管理地区', trigger: 'blur' },
        ],
        qq_area: [
          { required: true, message: '请选择QQ管理地区', trigger: 'blur' },
        ],
        nickname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        username: [
          { required: true, validator: validateUsername, trigger: 'change' },
        ],
        pwd: [{ validator: validatePass, trigger: 'change' }],
        confirmPwd: [{ validator: validatePass2, trigger: 'change' }],
      },
    }
  },
  created() {
    // 获取角色组 信息
    getRoleApi().then((res) => {
      if (res.code === 1) {
        this.roleList = res.list
      }
    })
    // 获取管理地区信息
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      }
    })
    // 获取项目信息
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
    this.areaList = store.getters.qqRoot
    // 获取表格中的数据
    this.getData()
  },
  methods: {
    // 取消修改
    cancel() {
      this.visible = false
      this.form = {
        id: undefined,
        groups: [],
        area: [],
        username: undefined,
        nickname: undefined,
        pwd: undefined,
        confirmPwd: undefined,
        category_id: undefined,
        area_path: [],
        qq_area: [],
      }
    },
    // 添加用户模态框弹出
    modify(record) {
      if (this.$HelperUtil.isEmpty(record)) {
        this.modalType = false
        this.record = {}
      } else {
        this.modalType = true
        this.form.id = record.id
        this.form.groups = record.group_id
        this.form.area = record.area_ids
        this.form.username = record.username
        this.form.nickname = record.nickname
        this.form.pwd = ''
        this.form.confirmPwd = ''
        this.form.category_id =
          record.category_id == 0 ? undefined : record.category_id
        this.form.area_path = record.area_path
        this.form.qq_area = record.qq_area
      }
      this.visible = !this.visible
    },
    setMajor(record) {
      set_major({
        id: record.id,
        major: record.major,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success({ content: res.msg, key: 'set_major' })
          this.getData()
        }
      })
    },
    // 搜索数据
    searchData() {
      // 查询数据
      this.table = []
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    // 修改用户状态
    modifyStatus(id, status) {
      modify_status({
        id: id,
        status: status,
      }).then((res) => {
        if (res.code === 1) {
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 获取数据
    getData() {
      this.loading.spinning = true
      get_admin_list({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        username: this.search.username,
        groups: this.search.groups,
        area: this.search.area,
      }).then((res) => {
        this.loading.spinning = false
        if (res.code === 1) {
          this.table = res.list
          this.pagination.total = res.count
        } else {
          this.pagination.total = 0
          this.$message.warning(res.msg)
        }
      })
    },
    // 确认添加用户
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            this.modalType === false &&
            this.$HelperUtil.isEmpty(this.form.pwd)
          ) {
            this.$message.warning('请输入密码!')
            return false
          }
          modify_admin(this.form).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
              this.cancel()
              this.getData()
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
  },
}
</script>
<style scoped></style>
